import { call, put, takeLatest, select } from 'redux-saga/effects';
import {
    checkEmailRequest, checkEmailFailure,
    checkEmailSuccess, verifyOtpFailure,
    verifyOtpRequest, verifyOtpSuccess, setOtpSuccess, setToken,
    savePreferrenceFailure, savePreferrenceRequest, savePreferrenceSuccess,
    fetchPreferencesFailure, fetchPreferencesRequest, fetchPreferencesSuccess,
    fetchPrefandNotifsFailure, fetchPrefandNotifsRequest, fetchPrefandNotifsSuccess
} from '../slices/userSlice';
import axios from 'axios';
import { resetApiLoader, setApiLoader } from '../slices/loaderSlice';

const URL = process.env.REACT_APP_API_BASE;

function* checkEmailSaga(action) {
    try {
        yield put(setApiLoader())
        const response = yield call(axios.get, URL + 'public-user-check', {
            params: { email: action.payload },
            headers: {
                Authorization: undefined
            }
        });
        if (response.data.redirection) {
            yield put(checkEmailSuccess({ redirection: true, otp: false }));
        } else {
            yield put(checkEmailSuccess({ redirection: false, otp: true }));
        }
    } catch (error: any) {
        console.log('api call failed', error.message)
        yield put(checkEmailFailure(error.message));
    } finally {
        yield put(resetApiLoader());
    }
}

function* verifyOtpSaga(action) {
    try {
        const response = yield call(axios.get, URL + 'user-otp', {
            params: { email: action.payload.email, otp: action.payload.otp },
            headers: {
                Authorization: undefined
            }
        });
        if (response.data.status === 'Successful') {
            const token = response.headers['x-token'];
            yield put(setToken({ xToken: token }));
            yield put(verifyOtpSuccess());
            yield put(setOtpSuccess(true));

        } else {
            yield put(verifyOtpFailure('Invalid OTP'));
        }
    } catch (error: any) {
        console.log('OTP verification failse', error);
        yield put(verifyOtpFailure(error));
    }
}

function* fetchPrefandNotifsSaga(action) {
    try {
        const token = yield select((state) => state.user.token.xToken);
        const response = yield call(axios.get, URL + 'public-notifs', {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        });
        if (response) {
            const { notifications, preferences } = response.data;
            yield put(fetchPrefandNotifsSuccess({ notifications, preferences }));
        } else {
            throw new Error('Failed to fetch notifications and preferrences');
        }
    } catch (error: any) {
        console.log('Error fetching notifications and preferrences', error);
        yield put(fetchPrefandNotifsFailure(error));
    }
}

function* fetchPreferenesSaga(action) {
    try {
        const token = yield select((state) => state.user.token.xToken);
        const response = yield call(axios.get, URL + 'public-notif-user', {
            params: { email: action.payload },
            headers: {
                Authorization: `Bearer ${token}`,
            }
        });
        if (response.data) {
            yield put(fetchPreferencesSuccess(response.data.data.userInfo));
        } else {
            throw new Error('Failed to fetch preferrences')
        }
    } catch (error: any) {
        console.log('save preferences failed', error);
        yield put(fetchPreferencesFailure(error));
    }
}

function* savePreferrencesSaga(action) {
    try {
        const token = yield select((state) => state.user.token.xToken);
        const response = yield call(axios.put, URL + 'public-notif-user', action.payload, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        });
        if (response.data.status === 'Successful') {
            yield put(savePreferrenceSuccess());
        } else {
            throw new Error('Failed to save preferrences')
        }
    } catch (error: any) {
        console.log('save preferences failed', error);
        yield put(savePreferrenceFailure(error));
    }
}

export default function* userSaga() {
    yield takeLatest(checkEmailRequest.type, checkEmailSaga);
    yield takeLatest(verifyOtpRequest.type, verifyOtpSaga);
    yield takeLatest(fetchPrefandNotifsRequest.type, fetchPrefandNotifsSaga);
    yield takeLatest(savePreferrenceRequest.type, savePreferrencesSaga);
    yield takeLatest(fetchPreferencesRequest.type, fetchPreferenesSaga);

}